import type { Media } from "@/types/media";

export const tvShows: Media[] = [
  {
    id: "t1",
    title: "琅琊榜",
    type: "tv",
    year: 2015,
    region: "大陆",
    genres: ["古装", "权谋", "剧情"],
    rating: 9.4,
    heat: 9120,
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%2C%20a%20scholar%20in%20flowing%20robes%20standing%20in%20a%20misty%20bamboo%20forest%2C%20ink%20wash%20teal%20and%20jade%20tones%2C%20elegant%20serene%20cinematic%20composition&width=400&height=600&seq=ph-tv-01&orientation=portrait",
    synopsis:
      "一代才子化名归来，隐忍十年运筹帷幄，只为昭雪沉冤、匡扶朝纲。智谋与忠义交织，谱写一曲荡气回肠的家国史诗。",
    director: "孔笙 / 李雪",
    cast: ["胡歌", "刘涛", "王凯", "陈龙"],
    episodes: 54,
  },
  {
    id: "t2",
    title: "权力的游戏",
    type: "tv",
    year: 2011,
    region: "美国",
    genres: ["奇幻", "剧情", "冒险"],
    rating: 9.5,
    heat: 9680,
    poster:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20drama%20poster%2C%20a%20lone%20figure%20before%20a%20towering%20icy%20wall%20under%20stormy%20skies%2C%20cold%20steel%20blue%20with%20ember%20accents%2C%20grand%20dramatic%20cinematic%20scale&width=400&height=600&seq=ph-tv-02&orientation=portrait",
    synopsis:
      "七大王国的权贵为铁王座明争暗斗，凛冬将至，古老的威胁悄然苏醒。权力、背叛与荣耀交织，命运在冰与火之间沉浮。",
    director: "大卫·贝尼奥夫 / D.B.魏斯",
    cast: ["艾米莉亚·克拉克", "基特·哈灵顿", "彼特·丁拉基"],
    episodes: 73,
  },
  {
    id: "t3",
    title: "甄嬛传",
    type: "tv",
    year: 2011,
    region: "大陆",
    genres: ["古装", "宫廷", "剧情"],
    rating: 9.3,
    heat: 8890,
    poster:
      "https://readdy.ai/api/search-image?query=imperial%20palace%20court%20drama%20poster%2C%20an%20elegant%20lady%20in%20embroidered%20silk%20hanfu%20before%20red%20palace%20gates%2C%20rich%20crimson%20and%20gold%20palette%2C%20regal%20refined%20atmosphere&width=400&height=600&seq=ph-tv-03&orientation=portrait",
    synopsis:
      "少女甄嬛入宫，从天真烂漫到步步为营，在深宫的权谋漩涡中沉浮。她以智慧与隐忍周旋，最终登上权力之巅。",
    director: "郑晓龙",
    cast: ["孙俪", "陈建斌", "蔡少芬", "蒋欣"],
    episodes: 76,
  },
  {
    id: "t4",
    title: "请回答1988",
    type: "tv",
    year: 2015,
    region: "韩国",
    genres: ["剧情", "家庭", "喜剧"],
    rating: 9.7,
    heat: 8940,
    poster:
      "https://readdy.ai/api/search-image?query=nostalgic%20family%20drama%20poster%2C%20a%20warm%20old%20neighborhood%20alley%20at%20dusk%20with%20hanging%20lights%2C%20soft%20golden%20and%20muted%20green%20tone%2C%20cozy%20heartwarming%20scene&width=400&height=600&seq=ph-tv-04&orientation=portrait",
    synopsis:
      "1988年的双门洞，五户人家比邻而居。柴米油盐间流淌着最真挚的邻里情、亲情与青春悸动，温暖了整个时代。",
    director: "申源浩",
    cast: ["惠利", "朴宝剑", "柳俊烈", "高庚杓"],
    episodes: 20,
  },
  {
    id: "t5",
    title: "隐秘的角落",
    type: "tv",
    year: 2020,
    region: "大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.8,
    heat: 8210,
    poster:
      "https://readdy.ai/api/search-image?query=tense%20crime%20mystery%20drama%20poster%2C%20three%20children%20silhouettes%20on%20a%20cliff%20by%20the%20sea%20at%20night%2C%20cold%20cyan%20and%20deep%20navy%20tone%2C%20suspenseful%20ominous%20mood&width=400&height=600&seq=ph-tv-05&orientation=portrait",
    synopsis:
      "三个孩子无意间拍下一场谋杀，从此卷入一场危险的博弈。天真与黑暗交错，平静的小城之下暗流涌动。",
    director: "辛爽",
    cast: ["秦昊", "王景春", "张颂文", "荣梓杉"],
    episodes: 12,
  },
  {
    id: "t6",
    title: "绝命毒师",
    type: "tv",
    year: 2008,
    region: "美国",
    genres: ["犯罪", "剧情", "惊悚"],
    rating: 9.5,
    heat: 9020,
    poster:
      "https://readdy.ai/api/search-image?query=crime%20drama%20poster%2C%20a%20man%20in%20hazmat%20suit%20standing%20in%20a%20desert%20wasteland%20under%20blazing%20sun%2C%20scorched%20yellow%20and%20dusty%20brown%20tone%2C%20gritty%20tense%20cinematic%20mood&width=400&height=600&seq=ph-tv-06&orientation=portrait",
    synopsis:
      "一位身患绝症的中学化学老师为家人铤而走险，踏上制毒之路。从平凡教师到毒枭巨头，一场人性的深渊之旅就此展开。",
    director: "文斯·吉利根",
    cast: ["布莱恩·科兰斯顿", "亚伦·保尔", "安娜·冈"],
    episodes: 62,
  },
  {
    id: "t7",
    title: "白夜追凶",
    type: "tv",
    year: 2017,
    region: "大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 9.0,
    heat: 7980,
    poster:
      "https://readdy.ai/api/search-image?query=noir%20detective%20drama%20poster%2C%20a%20man%20in%20a%20trench%20coat%20under%20a%20streetlamp%20on%20a%20rainy%20night%2C%20cool%20blue%20and%20neon%20teal%20reflections%2C%20moody%20mysterious%20atmosphere&width=400&height=600&seq=ph-tv-07&orientation=portrait",
    synopsis:
      "一对孪生兄弟共用同一身份，在白天与黑夜之间交替追凶。为了洗清冤屈，他们在真相与谎言之间步步惊心。",
    director: "王伟",
    cast: ["潘粤明", "王泷正", "梁缘", "吕晓霖"],
    episodes: 32,
  },
  {
    id: "t8",
    title: "觉醒年代",
    type: "tv",
    year: 2021,
    region: "大陆",
    genres: ["历史", "剧情", "传记"],
    rating: 9.3,
    heat: 8010,
    poster:
      "https://readdy.ai/api/search-image?query=historical%20revolutionary%20drama%20poster%2C%20group%20of%20young%20scholars%20in%20early%2020th%20century%20attire%20under%20a%20red%20banner%2C%20muted%20sepia%20with%20deep%20red%20accents%2C%20inspiring%20epic%20tone&width=400&height=600&seq=ph-tv-08&orientation=portrait",
    synopsis:
      "以新文化运动为背景，再现一代先驱探索救国之路的峥嵘岁月。理想与热血激荡，唤醒一个时代的沉睡灵魂。",
    director: "张永新",
    cast: ["于和伟", "张桐", "马少骅", "朱刚日尧"],
    episodes: 43,
  },
  {
    id: "t9",
    title: "切尔诺贝利",
    type: "tv",
    year: 2019,
    region: "美国",
    genres: ["剧情", "历史", "惊悚"],
    rating: 9.6,
    heat: 8480,
    poster:
      "https://readdy.ai/api/search-image?query=haunting%20disaster%20drama%20poster%2C%20an%20abandoned%20industrial%20reactor%20tower%20under%20ashen%20grey%20sky%2C%20desaturated%20cold%20blue-grey%20palette%2C%20bleak%20eerie%20cinematic%20mood&width=400&height=600&seq=ph-tv-09&orientation=portrait",
    synopsis:
      "1986年的核电站事故撕裂了平静的生活。无数普通人以血肉之躯直面灾难，一场关于谎言、勇气与牺牲的真实编年史。",
    director: "约翰·伦克",
    cast: ["贾里德·哈里斯", "斯特兰·斯卡斯加德", "艾米丽·沃森"],
    episodes: 5,
  },
  {
    id: "t10",
    title: "庆余年",
    type: "tv",
    year: 2019,
    region: "大陆",
    genres: ["古装", "喜剧", "权谋"],
    rating: 8.0,
    heat: 7760,
    poster:
      "https://readdy.ai/api/search-image?query=lighthearted%20costume%20adventure%20drama%20poster%2C%20a%20young%20man%20with%20a%20fan%20in%20ancient%20pavilion%20amid%20autumn%20leaves%2C%20warm%20amber%20and%20jade%20green%20tone%2C%20playful%20elegant%20scene&width=400&height=600&seq=ph-tv-10&orientation=portrait",
    synopsis:
      "少年范闲携神秘身世踏入京都，在庙堂与江湖之间周旋。机智幽默的背后，是暗涌的权谋与深藏的真相。",
    director: "孙皓",
    cast: ["张若昀", "李沁", "陈道明", "吴刚"],
    episodes: 46,
  },
  {
    id: "t11",
    title: "纸牌屋",
    type: "tv",
    year: 2013,
    region: "美国",
    genres: ["政治", "剧情", "惊悚"],
    rating: 9.0,
    heat: 7420,
    poster:
      "https://readdy.ai/api/search-image?query=political%20thriller%20drama%20poster%2C%20a%20stern%20man%20in%20a%20dark%20suit%20seated%20in%20a%20dim%20marble%20hall%2C%20cold%20desaturated%20blue-grey%20palette%2C%20calculating%20powerful%20mood&width=400&height=600&seq=ph-tv-11&orientation=portrait",
    synopsis:
      "一位野心勃勃的政客在权力之路上步步为营，用阴谋与算计攀上顶峰。光鲜的华盛顿之下，是一场没有硝烟的战争。",
    director: "鲍尔·威利蒙",
    cast: ["凯文·史派西", "罗宾·怀特", "凯特·玛拉"],
    episodes: 73,
  },
  {
    id: "t12",
    title: "我的天才女友",
    type: "tv",
    year: 2018,
    region: "意大利",
    genres: ["剧情", "家庭", "女性"],
    rating: 9.3,
    heat: 7120,
    poster:
      "https://readdy.ai/api/search-image?query=coming%20of%20age%20drama%20poster%2C%20two%20young%20girls%20walking%20hand%20in%20hand%20through%20a%20sunlit%20old%20Italian%20town%20alley%2C%20warm%20terracotta%20and%20dusty%20olive%20tone%2C%20nostalgic%20intimate%20scene&width=400&height=600&seq=ph-tv-12&orientation=portrait",
    synopsis:
      "在那不勒斯的旧城区，两个女孩相伴成长。友谊、嫉妒与梦想交织，映照出女性一生的挣扎与蜕变。",
    director: "萨维里奥·科斯坦佐",
    cast: ["伊莱莎·德尔·杰尼奥", "卢多维卡·纳斯提"],
    episodes: 8,
  },
];